// src/routes.jsx
export const routes = [
  {
    path: '/',
    title: 'Home',
    protected: true,
  },
  {
    path: '/pixels',
    title: 'Pixels',
    protected: true,
  },
  {
    path: '/integrations',
    title: 'Integrations',
    protected: true,
  },
  {
    path: '/profile',
    title: 'Profile',
    protected: true,
  },
  {
    path: '/login',
    title: 'Login',
    protected: false,
  },
];
